import { useEffect, useState } from "react";
import { FIREDB } from "../firebaseInstance";
import { onValue, ref, off } from "firebase/database";
import Bugsnag from "@bugsnag/js";
import { logout } from "../Store/Actions";
import { useDispatch } from "react-redux";

const ONLINE_STATUS = "Online";
const OFFLINE_STATUS = "Offline";
const TYPING_STATUS = "Typing";

const acceptableAvailabilityTypes = [
  ONLINE_STATUS,
  OFFLINE_STATUS,
  TYPING_STATUS,
];

const getDefaultChatStatus = () => ONLINE_STATUS;

const isValidStatus = status => acceptableAvailabilityTypes.includes(status);

export const useChatStatus = firebaseId => {
  const dispatch = useDispatch();
  const [chatStatus, setChatStatus] = useState(null);

  useEffect(() => {
    if (!firebaseId) return;

    const dbRef = ref(FIREDB, "Status/" + firebaseId);

    const fetchChatStatusFromFirebase = () => {
      onValue(dbRef, snapshot => {
        try {
          const status = snapshot.val();
          if (status && isValidStatus(status)) {
            setChatStatus(status);
          } else {
            setChatStatus(getDefaultChatStatus());
          }
        } catch (err) {
          if (err?.code === "storage/unauthorized") {
            dispatch(logout());
          }
          console.error({ err });
          Bugsnag.notify(err);
          setChatStatus(getDefaultChatStatus());
        }
      });
    };

    fetchChatStatusFromFirebase();

    return () => off(dbRef);
  }, [firebaseId]);

  return { chatStatus };
};
